<h2 mat-dialog-title class="label-orange-color" translate>remove.notification</h2>
<mat-dialog-content>
	<div class="copo-simple-dialog-content">
		<div>
			<span class="dialog-content-font" translate>want.to.delete.notification</span>
			<b><span class="label-orange-color"> {{ notification.subscribers.name }} </span></b> ?
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group">
	<button type="button" mat-button class="copo-button-font" (click)="cancel()">
		<span translate>filter.cancel</span>
	</button>
	<button type="submit" mat-button class="copo-blue-dark-grey-button" (click)="validate()">
		<span translate>dashboard.validate</span>
	</button>
</mat-dialog-actions>
